import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fa6feb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background-setting-container" }
const _hoisted_2 = {
  key: 0,
  class: "effect-not-suppot"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This browser does not support video effect", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "video-box" }
const _hoisted_6 = { class: "video-off" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please enable camera before use video effect", -1))
const _hoisted_8 = [
  _hoisted_7
]

import { useDeviceStore } from '@/stores'
import { Engine } from '@/types/enums/room.enum'
import { computed, defineAsyncComponent, PropType } from 'vue'
import BackgroundGallery from '@/components/checkup/BackgroundGallery.vue'
import { Stream } from '@zoom/videosdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'BackgroundSetting',
  props: {
  engine: {
    type: String as PropType<Engine>,
    default: Engine.TWILIO,
  },
  // for Zoom
  mediaStream: {
    type: Object as PropType<typeof Stream>,
    default: undefined,
  },
},
  setup(__props) {

const VideoTwilio = defineAsyncComponent(() => import('@/components/checkup/VideoTwilio.vue'))
const VideoZoom = defineAsyncComponent(() => import('@/components/checkup/VideoZoom.vue'))

const props = __props

const device = useDeviceStore()

const canChangeBackground = computed(() => device.canChangeBackground)

/**
 * Computed
 */
const videoComponentByEngine = computed(() => {
  if (props.engine === Engine.TWILIO) return VideoTwilio
  else if (props.engine === Engine.ZOOM) return VideoZoom
  else return ''
})

return (_ctx: any,_cache: any) => {
  const _component_LoadingProcess = _resolveComponent("LoadingProcess")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!canChangeBackground.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_LoadingProcess, {
              loading: _unref(device).isProcessing
            }, null, 8, ["loading"]),
            (videoComponentByEngine.value && _unref(device).maskCameraOn)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(videoComponentByEngine.value), {
                  key: 0,
                  "media-stream": __props.mediaStream
                }, null, 8, ["media-stream"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512), [
              [_vShow, !_unref(device).maskCameraOn]
            ])
          ]),
          _createVNode(BackgroundGallery)
        ], 64))
  ]))
}
}

})